import React, { useEffect } from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Navbar from './Navbar';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.adsbygoogle) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (err) {
        console.error('AdSense error:', err);
      }
    }
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      backgroundImage: 'url(/home.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundAttachment: 'fixed',
      backgroundRepeat: 'no-repeat',
      margin: 0,
      padding: 0,
      width: '100%',
      position: 'relative'
    }}>
      <Navbar />
      {/* <div style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
        <ins
          className="adsbygoogle"
          style={{ display: 'block' }}
          data-ad-client="ca-pub-4558262338290493"
          data-ad-slot="9665979324"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div> */}
      <Container style={{ paddingBottom: '25px', flex: '1 0 auto' }}>
        {/* Hero Section */}
        <Box sx={{ 
            mt: { xs: 2, sm: 3, md: 4 },
            mb: 8,
            p: 6,
            backgroundColor: 'rgba(255, 255, 255, 0.55)',
            borderRadius: 2,
            textAlign: 'center',
            boxShadow: 3,
          }}>
          <Typography variant="h3" gutterBottom sx={{ 
            color: 'primary.main', 
            fontWeight: 'bold',
            textShadow: '2px 2px 4px rgba(79, 85, 88, 0.93)'
          }}>
            {t('home.welcome')}
          </Typography>
          <Typography variant="h5" sx={{ color: 'text.secondary', mb: 4 }}>
            {t('home.perfectHome')}
          </Typography>
          
          <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'center', 
            gap: { xs: 3, md: 4 }, 
            mb: 4,
            px: { xs: 2, sm: 3, md: 4 }
          }}>
            <Box sx={{ 
              textAlign: 'center',
              width: { xs: '100%', md: '50%' },
              maxWidth: { md: '500px' },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              height: '100%'
            }}>
              <Button 
                variant="contained" 
                color="primary" 
                size="large"
                sx={{ 
                  px: { xs: 3, md: 4 },
                  py: 1.5,
                  fontSize: { xs: '1rem', md: '1.1rem' },
                  mb: 2,
                  width: { xs: '100%', sm: 'auto' },
                  height: '48px'
                }}
                onClick={() => navigate('/dashboard')}
              >
                {t('home.listProperty')}
              </Button>
              <Typography variant="body1" sx={{ 
                color: 'text.secondary', 
                fontSize: { xs: '1rem', md: '1.1rem' }, 
                lineHeight: 1.6,
                textAlign: 'left',
                px: { xs: 1, sm: 2 }
              }}>
                {t('home.listPropertyDescription')}
              </Typography>
            </Box>

            <Box sx={{ 
              textAlign: 'center',
              width: { xs: '100%', md: '50%' },
              maxWidth: { md: '500px' },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              height: '100%'
            }}>
              <Button 
                variant="outlined" 
                color="primary" 
                size="large"
                sx={{ 
                  px: { xs: 3, md: 4 },
                  py: 1.5,
                  fontSize: { xs: '1rem', md: '1.1rem' },
                  mb: 2,
                  width: { xs: '100%', sm: 'auto' },
                  backgroundColor: 'rgba(255, 255, 255, 0.56)',
                  border: '2px solid',
                  boxShadow: 3,
                  height: '48px',
                  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.34)',
                    border: '2px solid',
                    boxShadow: 4,
                    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.4)'
                  }
                }}
                onClick={() => navigate('/apartments')}
              >
                {t('home.findApartment')}
              </Button>
              <Typography variant="body1" sx={{ 
                color: 'text.secondary', 
                fontSize: { xs: '1rem', md: '1.1rem' }, 
                lineHeight: 1.6,
                textAlign: 'left',
                px: { xs: 1, sm: 2 }
              }}>
                {t('home.findApartmentDescription')}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
      <div style={{ display: 'flex', justifyContent: 'center', margin: '25px 0' }}>
        <ins
          className="adsbygoogle"
          style={{ display: 'block' }}
          data-ad-client="ca-pub-4558262338290493"
          data-ad-slot="9665979324"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
      <Footer />
    </div>
  );
};

export default Home;